import { Flex, Text } from '@radix-ui/themes';
import React from 'react';

interface InfoFieldProps {
  subtitle: React.ReactNode;
  children: React.ReactNode;
  separator?: boolean;
  bold?: boolean;
  requiresResubmission?: boolean;
}

export default function InfoField({
  subtitle,
  children,
  bold = true,
  separator,
  requiresResubmission = false,
}: InfoFieldProps): JSX.Element {
  return (
    <div className="w-full">
      <Flex mb={separator ? '4' : '0'} direction="column" gap="1" maxWidth="32rem">
        <Text size="2" weight={bold ? 'bold' : 'medium'} color="gray">
          {subtitle}
        </Text>
        {requiresResubmission ? (
          <Text size="1" color="amber" mb="1">
            The previous response you submitted requires additional information or clarification.
            Please review the response and make any necessary changes so that we can continue
            reviewing your application.
          </Text>
        ) : null}
      </Flex>
      {children}
    </div>
  );
}
